import { Component, OnInit } from '@angular/core';
import { GlobalGuideService } from 'src/app/v2/views/global-guide/global-guide.service';

@Component({
  selector: 'global-guide-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class GlobalGuideDetailComponent implements OnInit {

  constructor(public service: GlobalGuideService) {
  }

  ngOnInit() {
  }

}
